///<reference path="../common/text-total-selected.ts"/>

module Meevo.Components.Controls.SmartMover {

    export class TotalSelectedReportTaxesText extends TextTotalSelected implements ITextTotalSelected {

        get className() {
            return {
                'color-red': this.collection.selectedModels.length >= MAX_SELECTED_TAXES,
                'text-bold': this.collection.selectedModels.length >= MAX_SELECTED_TAXES
            };
        }

        constructor(public text: string, private collection: ReportTaxesCollection) {
            super(text);
        }
    }
}
